// extracted by mini-css-extract-plugin
module.exports = {"grid":"RasmusUserDetail_grid_3M5r-","break-long-word":"RasmusUserDetail_break-long-word_1524e"};